import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mosaic',
  templateUrl: './mosaic.component.html',
  styleUrls: ['./mosaic.component.sass']
})
export class MosaicComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
